// src/utilities/APIRoutes.js

// Environment-based configuration with FALLBACKS for safe migration
const getApiUrl = (stack, endpoint) => {
  const baseUrls = {
    auth: process.env.REACT_APP_AUTH_API || 'https://7w4u8pust6.execute-api.af-south-1.amazonaws.com/dev',
    user: process.env.REACT_APP_USER_API || 'https://3fih1ggwkl.execute-api.af-south-1.amazonaws.com/dev',
    tenant: process.env.REACT_APP_TENANT_API || 'https://511v8d4z27.execute-api.af-south-1.amazonaws.com/Dev',
    userCollection: process.env.REACT_APP_USER_COLLECTION_API || 'https://djf05d6zdi.execute-api.af-south-1.amazonaws.com/dev',
    collection: process.env.REACT_APP_COLLECTION_API || 'https://vri8p3460e.execute-api.af-south-1.amazonaws.com/dev',
    chats: process.env.REACT_APP_CHATS_API || 'https://aycx0390vh.execute-api.af-south-1.amazonaws.com/test',
    chatSessions: process.env.REACT_APP_CHAT_SESSIONS_API || 'https://n6sa5pp244.execute-api.af-south-1.amazonaws.com/test',
    aiBase: process.env.REACT_APP_API_BASE_URL || 'https://api.ace.aizatroncloud.com',
  };

  const base = baseUrls[stack];
  if (!base) {
    console.error(`API stack '${stack}' not configured`);
    return '';
  }

  return `${base}${endpoint}`;
};

const API_ENDPOINTS = {
  // AUTH STACK
  SignIn: getApiUrl('auth', '/signIn'),
  RefreshToken: getApiUrl('auth', '/refreshToken'),
  SignOut: getApiUrl('auth', '/signOut'),
  CognitoSignOut: getApiUrl('auth', '/signOutOkta'),
  GetSignInURL: getApiUrl('auth', '/getsigninurl'),

  // USER MANAGEMENT STACK
  ListUser: getApiUrl('user', '/list'),
  RetrieveUser: getApiUrl('user', '/retrieve'),
  CreateUser: getApiUrl('user', '/create'),
  UpdateUser: getApiUrl('user', '/update'),
  DeleteUser: getApiUrl('user', '/delete'),

  // TENANT MANAGEMENT STACK
  ListTenant: getApiUrl('tenant', '/list'),
  RetrieveTenant: getApiUrl('tenant', '/retrieve'),
  CreateTenant: getApiUrl('tenant', '/create'),
  UpdateTenant: getApiUrl('tenant', '/update'),
  DeleteTenant: getApiUrl('tenant', '/delete'),

  // USER COLLECTION STACK
  ListUserCollection: getApiUrl('userCollection', '/list'),
  RetrieveUserCollection: getApiUrl('userCollection', '/retrieve'),
  ShareUserCollection: getApiUrl('userCollection', '/share'),
  DeleteUserCollection: getApiUrl('userCollection', '/delete'),
  UnshareCollection: getApiUrl('userCollection', '/unshare'),

  // COLLECTION STACK
  ListCollections: getApiUrl('collection', '/list'),
  RetrieveCollection: getApiUrl('collection', '/retrieve'),
  CreateCollectionAI: getApiUrl('aiBase', '/rag/create_collection'),
  DeleteCollectionAI: getApiUrl('aiBase', '/rag/delete_collection'),
  UpdateCollection: getApiUrl('collection', '/update'),

  // CHAT MESSAGE STACK
  Message: getApiUrl('collection', '/retrieve'),

  // DOCUMENTS STACK
  UploadDocAI: getApiUrl('aiBase', '/rag/upload_files'),
  DeleteDocAI: getApiUrl('aiBase', '/rag/delete_files?collection_name &document_name &document_id'),
  DownloadFileAI: getApiUrl('aiBase', '/rag/download_file'),

  // MY CHATS STACK
  ListChats: getApiUrl('chats', '/list'),
  RetrieveChat: getApiUrl('chats', '/retrieve'),
  CreateChat: getApiUrl('chats', '/create'),
  CreateChatCollections: getApiUrl('chats', '/create'),
  GetChatResponse: getApiUrl('aiBase', '/rag/get_ace_rag_response?'),
  RetrieveChatHistory: getApiUrl('aiBase', '/rag/retrieve_chat_history'),
  RenameChat: getApiUrl('chats', '/update'),
  IncognitoChat: getApiUrl('aiBase', '/rag/incognito_chat'),

  // MY CHATS STACK [TEST/SESSIONS]
  ListChatsSessions: getApiUrl('chatSessions', '/list'),
  RetrieveChatSession: getApiUrl('chatSessions', '/retrieve'),
  CreateChatSession: getApiUrl('chatSessions', '/create'),

  // DATABASE STACK
  NoSQLDBConnect: getApiUrl('aiBase', '/nosql_chat/connect'),
  NoSQLDBChat: getApiUrl('aiBase', '/nosql_chat/chat'),
  SQLDBConnect: getApiUrl('aiBase', '/sql_chat/connect'),
  SQLDBChat: getApiUrl('aiBase', '/sql_chat/chat'),
  DynamoDBConnect: getApiUrl('aiBase', '/dynamo_chat/connect'),
  DynamoDBChat: getApiUrl('aiBase', '/dynamo_chat/chat'),

  CSVUpload: getApiUrl('aiBase', '/csv_chat/upload'),
  CSVChat: getApiUrl('aiBase', '/csv_chat/chat/{file_id}'),
  CSVVisualization: getApiUrl('aiBase', '/csv_chat/visualize/{file_id}'),

  GetDynamoFields: getApiUrl('aiBase', '/dynamo_chat/get_fields/{collection_id}'),
  GetNoSQLCollections: getApiUrl('aiBase', '/nosql_chat/get_collections/{collection_id}'),
  GetSQLTables: getApiUrl('aiBase', '/sql_chat/get_tables/{collection_id}'),
};

// Log current environment on initialization (helpful for debugging)
if (process.env.NODE_ENV === 'development') {
  console.log(' API Environment:', process.env.REACT_APP_ENV || 'development (default)');
  console.log(' API Base URL:', process.env.REACT_APP_API_BASE_URL || 'https://api.ace.aizatroncloud.com (default)');
}

export default API_ENDPOINTS;